"use client";

import { createContext, useContext, useMemo, useState } from "react";
import type { AppLocale } from "@/lib/utils/i18n";

type LocaleAlternates = Partial<Record<AppLocale, string>>;

type LocaleAlternatesContextValue = {
  alternates: LocaleAlternates | null;
  setAlternates: (value: LocaleAlternates | null) => void;
};

const LocaleAlternatesContext = createContext<LocaleAlternatesContextValue | null>(null);

export const LocaleAlternatesProvider = ({ children }: { children: React.ReactNode }) => {
  const [alternates, setAlternates] = useState<LocaleAlternates | null>(null);

  const value = useMemo(() => ({ alternates, setAlternates }), [alternates]);

  return <LocaleAlternatesContext.Provider value={value}>{children}</LocaleAlternatesContext.Provider>;
};

export const useLocaleAlternates = () => {
  const context = useContext(LocaleAlternatesContext);
  return context?.alternates ?? null;
};

export const useSetLocaleAlternates = () => {
  const context = useContext(LocaleAlternatesContext);
  return context?.setAlternates ?? (() => {});
};
